// Authentication utility functions

import { signInWithPopup, signOut, signInWithEmailAndPassword } from 'firebase/auth';

export const handleLogin = async (auth, provider, setLoginModalOpen) => {
  try {
    await signInWithPopup(auth, provider);
    // Don't manually set user - onAuthStateChanged will handle it
    setLoginModalOpen(false);
  } catch (error) {
    console.error('Login error:', error);
    
    // Provide more helpful error messages
    let errorMessage = error.message;
    if (error.code === 'auth/popup-closed-by-user') {
      errorMessage = 'Login cancelled. Please try again.';
    } else if (error.code === 'auth/popup-blocked') {
      errorMessage = 'Pop-up blocked by browser. Please allow pop-ups for this site.';
    } else if (error.code === 'auth/unauthorized-domain') {
      errorMessage = 'This domain is not authorized. Please contact support.';
    } else if (error.code === 'auth/cancelled-popup-request') {
      errorMessage = 'Login cancelled. Please try again.';
    } else if (error.code === 'auth/account-exists-with-different-credential') {
      errorMessage = 'An account already exists with the same email address but different sign-in credentials. Try signing in with a different method.';
    }
    
    alert(errorMessage);
  }
};

export const handleLogout = async (auth, setUser) => {
  try {
    await signOut(auth);
    setUser(null);
  } catch (error) {
    alert(error.message);
  }
};

export const handleEmailLogin = async (auth, email, password, setLoginModalOpen) => {
  try {
    await signInWithEmailAndPassword(auth, email, password);
    // Don't manually set user - onAuthStateChanged will handle it
    setLoginModalOpen(false);
  } catch (error) {
    alert(error.message);
  }
};
